var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"w-full h-full border-0",attrs:{"src":'https://gala.talentprint.com/users/manage_raters/'+_vm.autoLoginToken}})])}
var staticRenderFns = []

export { render, staticRenderFns }